export function gridLineStarts(
  min: number,
  max: number,
  cell: number,
): number[] {
  if (cell <= 0 || max < min) {
    return [];
  }

  const start = Math.floor(min / cell) * cell;
  const lines: number[] = [];

  for (let value = start; value <= max; value += cell) {
    lines.push(value);
  }

  return lines;
}

export function gridCellMeters(
  zoom: number,
  pixelsPerMeter: number,
  cellPx: number,
): number {
  if (zoom <= 0 || pixelsPerMeter <= 0 || cellPx <= 0) {
    return 0;
  }

  return cellPx / (pixelsPerMeter * zoom);
}

export function formatScaleLabel(meters: number): string {
  if (!Number.isFinite(meters) || meters < 0) {
    return '0 m';
  }

  if (meters >= 1000) {
    const kilometers = meters / 1000;

    if (Number.isInteger(kilometers)) {
      return `${kilometers} km`;
    }

    return `${formatMetersNumber(kilometers)} km`;
  }

  return `${formatMetersNumber(meters)} m`;
}

function formatMetersNumber(value: number): string {
  if (Number.isInteger(value) || Math.abs(value - Math.round(value)) < 1e-9) {
    return String(Math.round(value));
  }

  return String(Number(value.toFixed(1)));
}
